import { urlQueryParamsCreator } from '../client-api/query-params'
import { ProjectSearchEntityType } from './project'

export type GetUserSearchParams = {
  query?: string | null
  entityType?: ProjectSearchEntityType | null
  limit?: number
  offset?: number
}

const endpoints = {
  profileData: 'api/v2/users/user-id',
  profileUpdate: 'Api/profile',
  profilePasswordUpdate: 'Api/profile',
  promocodes: 'api/v2/users/user-id/promocodes',
  getUserSearch: ({ query, entityType, limit, offset }: GetUserSearchParams): string => {
    const params = urlQueryParamsCreator({
      query,
      entityType,
      limit,
      offset,
    })

    return `api/v2.5/users/user-id/search${params}`
  },
}

export default endpoints
